import { useCallback, useState } from "react";
import { Button, UploadIcon } from "melco-ui";
import { useDropzone } from "react-dropzone";
import { useQueryClient } from "react-query";
//import { useUploadFile } from "../../hooks/localestrings/useUploadFile";

type FileUploadButtonProps = {

  uploadFile: (file: any) => void
};


export const FileUploadButton: React.FC<FileUploadButtonProps> = ({

  uploadFile
}) => {
  //const { t } = useTranslation();

  const [isLoading,] = useState(false);
  const queryClient = useQueryClient();

  // const { uploadFile } = useUploadFile(productCode, cultureCode);


  const onDrop = useCallback(
    async (acceptedFiles: File[]) => {
      //      setIsLoading(true);
      for (const file of acceptedFiles) {
        try {
          await uploadFile(file);
          //refetch()
        } catch (error) { }
        queryClient.invalidateQueries("uploadFile");
      }
      //    setIsLoading(false);
    },
    [uploadFile, queryClient]
  );

  const { getInputProps, open } = useDropzone({
    onDrop,
    noClick: true,
    noKeyboard: true,
  });

  return (
    <>
      <input {...getInputProps()} />

      <Button
        //  disabled={cultureCode == undefined}
        key="downloads-upload"
        type="primary"
        //icon={<UploadIcon />}
        onClick={() => {
          open();
        }}
        loading={isLoading}
      >
        {/* {t("localestrings.actions.upload.button")} */}
        <UploadIcon />
      </Button>

    </>
  );
};
